module.exports = __webpack_public_path__ + "static/media/money.5b362d7b.svg";